export const ERROR_ORIGIN = {
  search: "ERROR_ORIGIN_SEARCH",
  saveItem: "ERROR_ORIGIN_SAVE_ITEM"
};
